import request from '@/utils/request'

export function getCateGroyList (data) {
  return request({
    url: '/home/home/getCateGroyList',
    method: 'post',
    data
  })
}

export function getCartCount (data) {
  return request({
    url: '/home/home/getCartCount',
    method: 'post',
    data
  })
}

export function getSearchKeywords (data) {
  return request({
    url: '/home/search/getSearchKeywords',
    method: 'post',
    data
  })
}

export function getMassageCount (data) {
  return request({
    url: '/home/task/getMassageCount',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/module.js